import React, { Component } from 'react';
import { _Alert, variable, _post, _getToken } from './Function';
import InputMask from 'react-input-mask';
import Modal from 'react-responsive-modal';
import '../css/Dashboard.css';

const $ = window.$;

class ModalAddress extends Component {
    constructor(props) {
        super(props);
        this.state={
            is_show: this.props.onShowAddressModal,
            current_address: {
                c_address_no: this.props.onCurrentAddress.c_address_no,
                c_address_moo: this.props.onCurrentAddress.c_address_moo,
                c_address_village: this.props.onCurrentAddress.c_address_village,
                c_address_road: this.props.onCurrentAddress.c_address_road,
                c_address_soi: this.props.onCurrentAddress.c_address_soi,
                c_district_id: this.props.onCurrentAddress.c_district_id,
                c_amphur_id: this.props.onCurrentAddress.c_amphur_id,
                c_province_id: this.props.onCurrentAddress.c_province_id,
                c_zipcode: this.props.onCurrentAddress.c_zipcode
            },
            province: {},
            amphur: {},
            district: {},
            amphur_original: {},
            district_original: {}
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ 
            is_show: nextProps.onShowAddressModal,
            current_address: {
                c_address_no: nextProps.onCurrentAddress.c_address_no,
                c_address_moo: nextProps.onCurrentAddress.c_address_moo,
                c_address_village: nextProps.onCurrentAddress.c_address_village,
                c_address_road: nextProps.onCurrentAddress.c_address_road,
                c_address_soi: nextProps.onCurrentAddress.c_address_soi,
                c_district_id: nextProps.onCurrentAddress.c_district_id,
                c_amphur_id: nextProps.onCurrentAddress.c_amphur_id,
                c_province_id: nextProps.onCurrentAddress.c_province_id,
                c_zipcode: nextProps.onCurrentAddress.c_zipcode
            }
        });
        if ( nextProps.onShowAddressModal ) {
            setTimeout(()=>{ $('.styles_modal__gNwvD').addClass("styles_address"); }, 100)
        }
        this.getProvince();
    }

    renderSelectBox(t) {
        if ( this.state.is_show ) {
            if ( t === 'province' ) {
                if ( this.state.province.length > 0 ) {
                  return this.state.province.map(value => (
                    <option key={value.province_id} value={value.province_id}>{value.province_name}</option>
                  ));
                }
              } else if ( t === 'amphur' ) {
                if ( this.state.amphur.length > 0 ) {
                  return this.state.amphur.map(value => (
                    <option key={value.amphur_id} value={value.amphur_id}>{value.amphur_name}</option>
                  ));
                }
              } else if ( t === 'district' ) {
                if ( this.state.district.length > 0 ) {
                  return this.state.district.map(value => (
                    <option key={value.district_id} value={value.district_id}>{value.district_name}</option>
                  ));
                }
            }
        }
    }

    onOpenModal = () => { this.setState({ is_show: true }); }
     
    onCloseModal = () => { this.setState({ is_show: false }); }

    updateModalInput = (t, e) => {
        this.setState({ current_address: Object.assign({}, this.state.current_address, { [t]: e.target.value, }) });
    }

    getProvince() {
        this.setState({ loadingShow: true });
        let param = { token: _getToken(), platform: variable().platform };
        _post('web.address.php', param)
        .then(res => {
            this.setState({
                province: res.data.province,
                amphur: res.data.current_amphur,
                district: res.data.current_district,
                amphur_original: res.data.amphur,
                district_original: res.data.district
            })
        });
    }

    dropdownChanged = (t, e) => {
        if ( t === 'c_province_id' ) {
            this.setState({ amphur: {}, district: {} });
          this.setState({ current_address: Object.assign({}, this.state.current_address, { c_province_id: e.target.value, c_amphur_id: 0, c_district_id: 0 }) });
          setTimeout(()=>{
            this.setState({ amphur: this.state.amphur_original.filter(item => item.province_id === this.state.current_address.c_province_id) });
            console.clear();
          }, 1000);
        } else if ( t === 'c_amphur_id' ) {
            this.setState({ district: {} });
            this.setState({ current_address: Object.assign({}, this.state.current_address, { c_amphur_id: e.target.value, c_district_id: 0 }) });
            setTimeout(()=>{
              this.setState({ district: this.state.district_original.filter(item => item.amphur_id === this.state.current_address.c_amphur_id) });
              console.clear();
            }, 1000);
        } else if ( t === 'c_district_id' ) {
            this.setState({ current_address: Object.assign({}, this.state.current_address, { c_district_id: e.target.value }) });
        }
    }

    EditData = () => {
        this.props.closeAddressModal();
        this.setState({ is_show: false }); 
        let param = { token: _getToken(), platform: variable().platform, data_type: 'address', data_edit: JSON.stringify(this.state.current_address) };
        _post('web.edit.dashboard.php', param)
        .then(res => {
            if ( res.data.status ) { 
                this.props.onFallback(true);
                _Alert('modify', 'success', 'แก้ไขข้อมูลสำเร็จแล้ว', 'แก้ไขข้อมูลสำเร็จแล้ว');
            } else {
                this.setState({ loadingShow: false });
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                } else {
                    _Alert('modify', 'error', 'แจ้งเตือน', res.data.responseText);
                }
            }
        }).catch(err => { 
            this.setState({ loadingShow: false }); 
            _Alert('error'); 
        });
    }

    render() {
        return (
            <div>
                <Modal open={this.state.is_show} onClose={(e) => this.onCloseModal()} center>
                    <div className="modal-title">แก้ไขข้อมูล</div>
                    <div className="modal-address-content">
                        <div className="addr-row">
                            <div className="addr-content">
                                <label>เลขที่ : </label>
                                <input type="text" className="form-control" value={this.state.current_address.c_address_no} onChange={(e) => this.updateModalInput("c_address_no", e)} />
                            </div>
                            <div className="addr-content">
                                <label>หมู่ที่ : </label>
                                <InputMask className="form-control" mask="999999999" maskChar={null} value={this.state.current_address.c_address_moo} onChange={(e) => this.updateModalInput("c_address_moo", e)} />
                            </div>
                        </div>
                        <div className="addr-row">
                            <div className="addr-content">
                                <label>หมู่บ้าน : </label>
                                <input type="text" className="form-control" value={this.state.current_address.c_address_village} onChange={(e) => this.updateModalInput("c_address_village", e)} />
                            </div>
                            <div className="addr-content">
                                <label>ซอย : </label>
                                <input type="text" className="form-control" value={this.state.current_address.c_address_soi} onChange={(e) => this.updateModalInput("c_address_soi", e)} />
                            </div>
                        </div>
                        <div className="addr-row">
                            <div className="addr-content">
                                <label>ถนน : </label>
                                <input type="text" className="form-control" value={this.state.current_address.c_address_road} onChange={(e) => this.updateModalInput("c_address_road", e)} />
                            </div>
                            <div className="addr-content">
                                <label>จังหวัด : </label>
                                <select className="form-control" value={this.state.current_address.c_province_id} onChange={(e) => this.dropdownChanged('c_province_id', e)}>
                                    <option key={0} value={0}>--เลือกจังหวัด--</option>
                                    {this.renderSelectBox('province')}
                                </select>
                            </div>
                        </div>
                        <div className="addr-row">
                            <div className="addr-content">
                                <label>อำเภอ : </label>
                                <select className="form-control" value={this.state.current_address.c_amphur_id} onChange={(e) => this.dropdownChanged('c_amphur_id', e)}>
                                    <option key={0} value={0}>--เลือกอำเภอ--</option>
                                    {this.renderSelectBox('amphur')}
                                </select>
                            </div>
                            <div className="addr-content">
                                <label>ตำบล : </label>
                                <select className="form-control" value={this.state.current_address.c_district_id} onChange={(e) => this.dropdownChanged('c_district_id', e)}>
                                    <option key={0} value={0}>--เลือกตำบล--</option>
                                    {this.renderSelectBox('district')}
                                </select>
                            </div>
                        </div>
                        <div className="addr-row">
                            <div className="addr-content">
                                <label>รหัสไปรษณีย์ : </label>
                                <InputMask className="form-control" mask="99999" maskChar={null} value={this.state.current_address.c_zipcode} onChange={(e) => this.updateModalInput("c_zipcode", e)} />
                            </div>
                        </div>
                        <div className="addr-row addr-btn">
                            <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.EditData()}>แก้ไข</button>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default ModalAddress;